import { useEffect, useRef } from "react";
import { logMetric } from "./collector";

export const usePerformanceMeasure = (
  componentName: string,
  threshold = 16,
) => {
  const renderStart = useRef<number | null>(null);

  useEffect(() => {
    renderStart.current = performance.now();
  });

  useEffect(() => {
    return () => {
      if (renderStart.current !== null) {
        const duration = performance.now() - renderStart.current;
        if (duration > threshold) {
          logMetric({
            type: "component-render",
            component: componentName,
            duration,
            timestamp: Date.now(),
          });
        }
      }
    };
  }, [componentName, threshold]);
};
